import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isMobile = window.innerWidth <= 768;
  
  const navStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    padding: isMobile ? '12px 15px' : '15px 20px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: "'Nunito', sans-serif",
    flexWrap: 'wrap',
    gap: '10px'
  };

  const navLinks = [
    { path: '/dashboard/learning-hub', label: 'Learning Hub', icon: '🎓' },
    { path: '/dashboard/teacher', label: 'Teacher Dashboard', icon: '👨‍🏫' }
  ];

  return (
    <nav style={navStyle}>
      <Link
        to="/dashboard/learning-hub"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          textDecoration: 'none',
          color: '#DD2E44',
          fontSize: '24px',
          fontWeight: '800'
        }}
      >
        <img
          src="https://static.wixstatic.com/media/174d84_79ee5070ea8344f79b737bd556619e15~mv2.png"
          alt="Paria"
          style={{
            height: '40px',
            width: '40px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
        <span>Paria.ai Dashboard</span>
      </Link>

      <div style={{
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            style={{
              textDecoration: 'none',
              color: isActive(link.path) ? '#DD2E44' : '#666',
              fontSize: '16px',
              fontWeight: isActive(link.path) ? '700' : '500',
              padding: '10px 15px',
              borderRadius: '20px',
              backgroundColor: isActive(link.path) ? '#FFF5F7' : 'transparent',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            onMouseEnter={(e) => {
              if (!isActive(link.path)) {
                e.target.style.color = '#DD2E44';
                e.target.style.backgroundColor = '#FFF5F7';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive(link.path)) {
                e.target.style.color = '#666';
                e.target.style.backgroundColor = 'transparent';
              }
            }}
          >
            <span>{link.icon}</span>
            <span>{link.label}</span>
          </Link>
        ))}
        <Link
          to="/"
          style={{
            textDecoration: 'none',
            color: '#666',
            fontSize: '16px',
            fontWeight: '500',
            padding: '10px 15px',
            borderRadius: '20px',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
          onMouseEnter={(e) => {
            e.target.style.color = '#DD2E44';
            e.target.style.backgroundColor = '#FFF5F7';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#666';
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          <span>🏠</span>
          <span>Home</span>
        </Link>
      </div>
    </nav>
  );
};

export default Navigation;